import { format, parseISO } from "date-fns";
import { fromZonedTime, toZonedTime, format as tzFormat } from "date-fns-tz";

export const convertToUserTimezone = (
  date: Date,
  time: string,
  timezone: string
) => {
  const [hours, minutes] = time.split(":").map(Number);
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const campaignDateTime = new Date(date);
  campaignDateTime.setHours(hours, minutes, 0, 0);

  const utcTime = fromZonedTime(campaignDateTime, timezone!);
  const userTime = toZonedTime(utcTime, userTimezone);

  const formattedDateTime = format(userTime, "MM/dd/yyyy, HH:mm");

  return {
    formattedDateTime,
    userTimezone,
  };
};

export const convertFromTimezoneToUtc = (
  timestamp: string,
  timezone: string
) => {
  if (!timestamp || !timezone) return;
  const utcDate = fromZonedTime(new Date(timestamp), timezone);
  return utcDate.toISOString();
};

export const convertUtcToLocalString = (
  utcTimestamp: string,
  format: string = "dd/MM/yyyy, hh:mm a",
  timezone?: string
) => {
  if (!utcTimestamp) return;
  const date = parseISO(utcTimestamp);
  const userTimeZone =
    timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const localDate = toZonedTime(date, userTimeZone);
  return tzFormat(localDate, format, { timeZone: userTimeZone });
};
